/* eslint-disable no-undef */

import wixService from '../services/wixService';
import axios from 'axios';

const httpRequests = {
  instance: () => wixService.Utils.getInstance(),
  compId: () => {
    const initialState = window.INITIAL_STATE || window.initialState;
    return initialState.locationParams.indexOf('endpointType=settings') > -1
      ? wixService.Utils.getOrigCompId()
      : wixService.Utils.getCompId();
  },
  // APIServerURL: initialState.APIServerURL,
  getUrlQuery() {
    return '?instance=' + this.instance() + '&compId=' + this.compId();
  },
  getReqParams(params) {
    const keys = Object.keys(params);
    let st = '';
    keys.forEach(function (key) {
      st += '&' + key + '=' + params[key];
    });
    return st;
  },
  post(url, params, cbs, cbf) {
    const urlQuery = this.getUrlQuery();
    return axios
      .post(url + urlQuery, params)
      .then(cbs)
      .catch(cbf);
  },
  get(url, params, cbs, cbf) {
    let urlQuery = this.getUrlQuery();
    urlQuery += this.getReqParams(params);

    const urlWindow = new URL(window.location.href);
    axios.defaults.baseURL = urlWindow.origin;

    return axios
      .get(url + urlQuery)
      .then(cbs)
      .catch(cbf);
  },
  delete(url, cbs, cbf) {
    url = 'https://localhost:9001/' + url;
    const urlQuery = this.getUrlQuery(false);
    console.log(url + urlQuery);
    return httpRequest
      .delete(url + urlQuery)
      .then(cbs)
      .catch(cbf);
  },
  publish(settings) {
    httpRequest.post('api/settings', { settings }, true);
  },
};

export default httpRequests;
